import { render, staticRenderFns } from "./PlanItemInclude.vue?vue&type=template&id=51984a85&scoped=true&"
import script from "./PlanItemInclude.vue?vue&type=script&lang=js&"
export * from "./PlanItemInclude.vue?vue&type=script&lang=js&"
import style0 from "./PlanItemInclude.vue?vue&type=style&index=0&id=51984a85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51984a85",
  null
  
)

export default component.exports